import React from "react";

function Check() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      id="Check"
      width="50%"
      height="50%"
    >
      <path
        d="M8.504 1.006a7.48 7.48 0 0 0-5.305 2.193C.274 6.124.274 10.882 3.2 13.807c2.925 2.924 7.683 2.924 10.608 0 2.924-2.925 2.924-7.683 0-10.608a7.475 7.475 0 0 0-5.303-2.193zm0 .994c1.662 0 3.324.635 4.596 1.906a6.494 6.494 0 0 1 0 9.194 6.494 6.494 0 0 1-9.194 0 6.494 6.494 0 0 1 0-9.194A6.482 6.482 0 0 1 8.504 2zm2.96 4.502a.5.5 0 0 0-.26.103L7.55 9.345 5.857 7.653a.5.5 0 1 0-.707.707l2 2a.5.5 0 0 0 .653.047l4-3a.5.5 0 0 0-.287-.904.5.5 0 0 0-.051 0z"
        fill="#ffffff"
      />
    </svg>
  );
}

export default Check;
